// TODO: Will be done in separate commit: See TRVX-10897

// @flow

import * as React from 'react';
import Popover from '@ta/overlays.popover';
import WindowScroll from '@ta/events.window-scroll';
import OverflowUIList from './OverflowUIList';

export type OverflowDirection = 'above' | 'below';

type Props = {
  /** A render prop that exposes ways to attach to an element */
  children: (target: React.ElementRef<*>, toggle: () => mixed) => React.Node,
  /** The overflow UI list to render on opening the overflow */
  overflowList: ?React.Element<typeof OverflowUIList>,
  /** Whether this should close when the user scrolls the page */
  closeOnScroll?: boolean,
  /** If the default shifts are just a little off */
  shiftX: number,
  shiftY: number,
  shiftArrow: number,
  overflowDirection?: OverflowDirection,
};

const OverflowOpener = ({
  children,
  overflowList,
  closeOnScroll,
  shiftX,
  shiftY,
  shiftArrow,
  overflowDirection,
}: Props) => (
  <Popover
    below={overflowDirection === 'below' || undefined}
    above={overflowDirection === 'above' || undefined}
    alignEdge="right"
    shiftX={10 + shiftX}
    shiftArrow={10 + shiftArrow}
    shiftY={shiftY}
    arrowType="small"
    contents={close => (overflowList ? React.cloneElement(overflowList, { close }) : null)}
    closeButton={false}
    local
  >
    {(target, open, close, isOpen) => (
      <React.Fragment>
        {children(target, () => {
          if (isOpen) {
            close();
          } else {
            open();
          }
        })}
        {closeOnScroll && isOpen && <WindowScroll callback={close} useCapture />}
      </React.Fragment>
    )}
  </Popover>
);

OverflowOpener.defaultProps = {
  children: () => null,
  closeOnScroll: false,
  overflowList: <OverflowUIList />,
  shiftX: 0,
  shiftY: 0,
  shiftArrow: 0,
  overflowDirection: 'below',
};

export default OverflowOpener;
